import { PLATFORM_DASHBOARD_READ } from '../../operations/dashboard.operations.js';
import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_REFRESH, AUTH_PASSWORD_CHANGE, AUTH_SESSION_MANAGE, AUTH_SESSION_REVOKE, AUTH_READ_PROFILE, AUTH_SWITCH_CONTEXT, NAVIGATION_SHELL_READ, NAVIGATION_ROUTES_READ, NAVIGATION_ROUTE_READ, NAVIGATION_HUB_READ, SETTINGS_VIEW, SETTINGS_PROFILE, SETTINGS_PROFILE_UPDATE, SETTINGS_PREFERENCES, SETTINGS_PREFERENCES_UPDATE, SETTINGS_MFA, SETTINGS_SECURITY, PLATFORM_HEALTH_LIVENESS, PLATFORM_AUDIT_LIST, PLATFORM_AUDIT_READ, } from '../../operations/operation-ids.js';
/**
 * Platform read-only user: platform dashboard and permitted platform audit
 * reads, and self-service settings. No admin or organization data hubs.
 */
export const PLATFORM_READ_OPERATIONS = [
    AUTH_LOGIN,
    AUTH_LOGOUT,
    AUTH_REFRESH,
    AUTH_PASSWORD_CHANGE,
    AUTH_SESSION_MANAGE,
    AUTH_SESSION_REVOKE,
    AUTH_READ_PROFILE,
    AUTH_SWITCH_CONTEXT,
    PLATFORM_DASHBOARD_READ,
    NAVIGATION_SHELL_READ,
    NAVIGATION_ROUTES_READ,
    NAVIGATION_ROUTE_READ,
    NAVIGATION_HUB_READ,
    SETTINGS_VIEW,
    SETTINGS_PROFILE,
    SETTINGS_PROFILE_UPDATE,
    SETTINGS_PREFERENCES,
    SETTINGS_PREFERENCES_UPDATE,
    SETTINGS_MFA,
    SETTINGS_SECURITY,
    PLATFORM_HEALTH_LIVENESS,
    PLATFORM_AUDIT_LIST,
    PLATFORM_AUDIT_READ,
];
